import React from 'react';
import {Tree} from './tree';

export default class CategoryMatchingFrom extends Tree{
	constructor(props){
		super(props);
		this.selectedItem = this.selectedItem.bind(this);
		this.onRemoveClick = this.onRemoveClick.bind(this);
	}

	selectedItem(e){
		let id = e.currentTarget.dataset.id;
		this.props.selectedItem(id)
	}

	onRemoveClick(e){
		e.preventDefault();
		let matchId = e.currentTarget.parentNode.dataset.matchId;
		this.props.removeMatch(matchId);
	}

	renderTitle(node){
		let selected_item = this.props.selectedItem();
		let classSelectedItem = selected_item === node.id ? 'tree-node-selected-item' : '';
		let classNotMatch =  node.matching_category.id ? '' : 'tree-node-not-match';
		return (
			<span className={`tree-node-title ${classSelectedItem} ${classNotMatch}`} onClick={this.selectedItem} data-id={node.id}>
			    <span>{node.title} ({node.count_products})</span>
				{node.matching_category.id ?
					(<span className='tree-node-natch-category' data-match-id={node.matching_category.id}> => {node.matching_category.title} <a className='glyphicon glyphicon-remove' onClick={this.onRemoveClick}> </a></span>) : null}
		    </span>
		);
	}
}



// WEBPACK FOOTER //
// ./frontend/components/CategoryMatchingFrom.js